import { Avatar } from "@tellescope/design-system";

interface CareTeamMemberOptionProps {
  userId: string;
  label: string;
  avatar?: string;
  initials: string;
}

export const CareTeamMemberOption = ({ userId, label, avatar, initials }: CareTeamMemberOptionProps) => (
  <div className="flex items-center gap-2">
    <Avatar size="sm" src={avatar} id={userId}>
      {initials}
    </Avatar>
    <span className="text-sm truncate">{label}</span>
  </div>
);
